import apiClient from "./axios"

export const getUsers = async (params = {}) => {
  const { data } = await apiClient.get("/users", { params });
  return data;
};

export const getUser = async identifier => {
  const { data } = await apiClient.get(`/users/${identifier}`)
  return data
}

export const createUser = async userData => {
  const { data } = await apiClient.post("/users", userData)
  return data
}

export const editUser = async ({ id, ...userData }) => {
  const { data } = await apiClient.patch(`/users/${id}`, userData)
  return data
}

export const deleteUser = async id => {
  const { data } = await apiClient.delete(`/users/${id}`)
  return data
}
